import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Logo from "./Logo";
import SocialMedia from "../styleHelper/SocialMedia"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone } from '@fortawesome/free-solid-svg-icons'

export default function Footer(props){
    return(
        <footer>
            <div className="upperFooter">
                <Container>
                    <Row className="align-items-center">
                        <Col md={9} className="footerLists">
                            <Row>
                            <Col xs={6} md={3}>
                                <h4>خدمات</h4>
                                <ul>
                                    <li>وب کنفرانس | وبینار</li>
                                    <li>کلاس آنلاین</li>
                                    <li>استفاده رایگان</li>
                                    <li>تعرفه ها</li>
                                </ul>
                            </Col>
                            <Col xs={6} md={3}>
                                <h4>دیداری</h4>
                                <ul>
                                    <li>درباره دیداری</li>
                                    <li>تماس با دیداری</li>
                                    <li>تیم دیداری</li>
                                </ul>
                            </Col>
                            <Col xs={6} md={3}>
                                <h4>کاربران</h4>
                                <ul>
                                    <li>ورود</li>
                                    <li>ثبت نام</li>
                                    <li>دمو رایگان</li>
                                </ul>
                            </Col>
                            <Col xs={6} md={3}>
                                <h4>دسترسی</h4>
                                <ul>
                                    <li>پرسش های رایج</li>
                                    <li><a href="/terms">قوانین و مقررات</a></li>
                                    <li>حریم خصوصی</li>
                                    <li>راهنما</li>
                                </ul>
                            </Col>    
                        </Row>
                        </Col>
                        <Col xs={12} sm={6} md={3} className="footerContactInfo">
                            <Logo/>
                            <div className="footerCallNumbers flexBox centerCenter">
                                <div>
                                    <div>۰۲۱-۶۶۹۴۲۶۶۰</div>
                                    <div>۰۳۱-۳۶۲۷۱۴۲۹</div>
                                </div>
                                <FontAwesomeIcon icon={faPhone} />
                            </div>
                            <SocialMedia/>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="copyright">
                <Container>
                    © تمامی حقوق برای پلتفرم بومی دیداری محفوظ می باشد - ایران 1399
                </Container>
            </div>
        </footer>
    )
}